import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';

import './DirectTooltipContent.css';

export interface DirectTooltipContentProps {
    header?: React.ReactNode;
    content: React.ReactNode;
    hasClose?: boolean;
    onCloseClick?: () => void;
}

const block = 'direct-tooltip-content';

export class DirectTooltipContent extends React.PureComponent<DirectTooltipContentProps> {
    render() {
        const { hasClose } = this.props;
        const closePresent = Boolean(hasClose);

        return (
            <div
                className={Bem.cls({
                    block,
                    mods: { 'has-close': closePresent }
                })}
            >
                {closePresent ? this.getClose() : null}
                {this.getHeader()}
                {this.getContent()}
            </div>
        );
    }

    private getHeader = (): React.ReactNode => {
        const { header } = this.props;
        if (header === undefined) {
            return null;
        }

        return <h3 className={Bem.cls(block, 'header')}>{header}</h3>;
    };

    private getContent = (): React.ReactNode => {
        return <h3 className={Bem.cls(block, 'content')}>{this.props.content}</h3>;
    };

    private getClose = () => {
        return (
            <span className={Bem.cls(block, 'close')} onClick={this.props.onCloseClick}>
                <Shape2 width={16} height={16} icon={Shape2Icon.close} theme={Shape2Theme.light} />
            </span>
        );
    };
}
